export enum HeaderMode {
    Discovery = 'discovery',
    Checkout = 'checkout',
    Booking = 'booking',
}
